import { httpClient } from './httpClient';
import type {
  GetPassTypesResponse,
  GetPassTypeResponse,
  CreatePassTypeRequest,
  CreatePassTypeResponse,
  UpdatePassTypeRequest,
  UpdatePassTypeResponse,
  DeletePassTypeResponse,
} from './types';

interface QueryOptions {
  signal?: AbortSignal;
}

interface PassTypesListEnvelope {
  items?: GetPassTypesResponse;
}

type PassTypesListResponse = GetPassTypesResponse | PassTypesListEnvelope;

const unwrapPassTypes = (response: PassTypesListResponse): GetPassTypesResponse => {
  if (Array.isArray(response)) {
    return response;
  }

  return response.items ?? [];
};

export const passTypesApi = {
  getAll: (options?: QueryOptions): Promise<GetPassTypesResponse> => {
    return httpClient
      .get<PassTypesListResponse>('/api/v1/pass-types', options)
      .then(unwrapPassTypes);
  },

  getById: (passTypeId: string, options?: QueryOptions): Promise<GetPassTypeResponse> => {
    return httpClient.get<GetPassTypeResponse>(`/api/v1/pass-types/${passTypeId}`, options);
  },

  create: (data: CreatePassTypeRequest): Promise<CreatePassTypeResponse> => {
    return httpClient.post<CreatePassTypeResponse>('/api/v1/pass-types', data);
  },

  update: (passTypeId: string, data: UpdatePassTypeRequest): Promise<UpdatePassTypeResponse> => {
    return httpClient.put<UpdatePassTypeResponse>(`/api/v1/pass-types/${passTypeId}`, data);
  },

  delete: (passTypeId: string): Promise<DeletePassTypeResponse> => {
    return httpClient.delete<DeletePassTypeResponse>(`/api/v1/pass-types/${passTypeId}`);
  },
} as const;
